import SelectivityDropdown from 'components/generic/SelectivityDropdown'
import { VString, Div, Button, all, reactive, if as _if, not, and, LI, UL, H3, A } from 'alkali'
import { studyFilter, importedCollections } from 'model/SearchQuery'
import { digitizedStudiesLoaded } from 'model/StudyCollection'
import app from 'app/app'
import Icon from 'components/Icon'
import * as downloadIcon from 'icons/download-button.svg'
import * as loadingIcon from 'icons/loading-half.svg'
import { downloadFile, getFileName } from 'lib/export/DownloadFile'
import exportCsv from 'lib/export/exportCsv'
import { keyBy } from 'lodash'

const DRE_CLIENT_ID = 3

let startingCollection = new VString()
export const ImportCollectionsSelector = ({ entrySelector }) => {
	const collection = entrySelector ? startingCollection.to(() => null, (value) => {
		location.search = 'imports=' + encodeURIComponent(value)
	}) : studyFilter.importCollection
	const eligibleStudies = all([collection, digitizedStudiesLoaded], (c, studies) =>
		c ? studies.filter(s =>
			s.source == 'ClinicalTrials.gov' ||
			app.user?.Client?.Id == DRE_CLIENT_ID ||
			(s.metadata?.Extractor?.Client?.Id == app.user?.Client?.Id)
		) : []
	)
	const canExport = app.userVar.to(user => user?.FeatureConfig?.['Build Analyses']?.Enabled)
	const busy = reactive()
	return Div('.import-collection-container', {
		content: importedCollections.to(importedCollections => importedCollections.length > 0 ? Promise.resolve(app.user).then(user => [
			SelectivityDropdown('.import-collection-selector', {
				classes: {
					'flat-right': eligibleStudies.to(studies => studies.length)
				},
				placeholder: 'Collections',
				allowClear: true,
				showSearchInputInDropdown: false,
				items: importedCollections.map(({ key, count }) => ({
					id: key,
					text: friendlyCollectionName(key) + ' (' + count + ')',
				})),
				value: collection
			}),
			Button({
				title: 'Export studies',
				type: 'button',
				disabled: busy,
				classes: {
					hidden: not(and(canExport, eligibleStudies.to(studies => studies.length))),
					disabled: busy
				},
				async onclick() {
					busy.put(true)
					const studies = eligibleStudies.valueOf()
					import('../../lib/export/StudyExport').then(async ({ StudyExport }) => {
						try {
							const exprt = await StudyExport.export(studies.map(s => s.id))
							const filename = getFileName({ name: 'ExportedStudies', includeTime: true }) + '.csv'
							const csvData = await exportCsv(exprt.exportStudies(), exprt.columns)
							const csvBlob = new Blob(['\uFEFF' + csvData], { type: 'text/csv' })
							downloadFile(filename, csvBlob)
						} catch (err) {
							alert('Error occurred during export: ' + err)
						} finally {
							busy.put(false)
						}
					})
				}
			}, _if(busy, [
				Icon('.spin-icon', { title: 'Exporting...', icon: loadingIcon }),
				Icon({ title: 'Export studies', icon: downloadIcon })
			]))
		])  : null)
	})
}
export function friendlyCollectionName(key) {
	return key == 'mine' ? 'My Rapid Extractions' :
						key == 'all' ? 'All Collections' :
							key == 'Manual Entry' ? 'Rapid Extractions' :
								key == 'uploaded' ? 'Uploaded Studies' :
									key == 'my-uploaded' ? 'My Uploaded Studies' :
										key
}


export const CollectionsGrouping = (collections) => {
	return collections.map((collection) => {
		let {key, count} = collection
		collection.id = key
		collection.text = friendlyCollectionName(key) + ' (' + count + ')',
		collection.link = `${location.search}?imports=${encodeURIComponent(key)}`
		if (key == 'all'){
			collection.type = 'all'
			collection.parent = true
		} else if (key == 'Manual Entry' || key == 'mine'){
			collection.type = 'extract'
			collection.parent = (key == 'Manual Entry')
		} else if (key == 'uploaded' || key == 'my-uploaded'){
			collection.type = 'uploaded'
			collection.parent = (key == 'uploaded')
		} else {
			collection.type = 'other'
			collection.parent = false
		}
		return collection
	})
}

export const CollectionLink = (collection, properties) => {
	const linkStyle = collection.parent ? '.collection-choice.parent-choice' : '.collection-choice'
	return LI(linkStyle, [
		A('.collection-link', {
			href: collection.link,
			content: [
				collection.text
			],
			onclick() {
				navigator.sendBeacon('/portal/track?event=open-from-' + properties.type)
			},
		}),
	])
}

export const CollectionsListing = (collections, properties) => {
    const allCollection = collections.filter((collection) => collection.type == 'all').valueOf([0])
	// NOTE: Do we have a find method for VArray? Got collections.find is not a function when
    const extractHeader = collections.filter((collection) => collection.type !== 'all' && collection.type == 'extract' && collection.parent == true ).valueOf([0])
    const extractChild = collections.filter((collection) => collection.type !== 'all' && collection.type == 'extract' && collection.parent == false ).valueOf([0])
    const uploadedHeader = collections.filter((collection) => collection.type !== 'all' && collection.type == 'uploaded' && collection.parent == true ).valueOf([0])
    const uploadedChild = collections.filter((collection) => collection.type !== 'all' && collection.type == 'uploaded' && collection.parent == false ).valueOf([0])
    const otherCollections = collections.filter((collection) =>collection.type !== 'all' && collection.type == 'other' )
    return UL('.collections-list', [
		Div([
			CollectionLink(allCollection[0], properties),
			UL('.collections-sub-list', [
				extractHeader.length > 0 ? CollectionLink(extractHeader[0], properties) : null,
				extractChild.length > 0 ?  UL('.collections-sub-list', [CollectionLink(extractChild[0], properties)]) : null,
				uploadedHeader.length > 0 ? CollectionLink(uploadedHeader[0], properties) : null,
				uploadedChild.length > 0 ?  UL('.collections-sub-list', [CollectionLink(uploadedChild[0], properties)]) : null,
			]),
		]),
		Div([
			H3('Study Collections'),
				UL('.collections-sub-list', [
					otherCollections.map((collection) => {
						return CollectionLink(collection, properties)
					})
			])
		])
    ])
}